module.exports = __webpack_public_path__ + "img/shape3.a52ca878.svg";